import mask from './modules/mask';
import formValidate from './modules/form.validate';
import Action from './modules/Action';


// jQuery
(function ($) {
  $(function () {

    let $body = $('body');
    let $window = $(window);


    // Клик
    $body.on('click', '[data-click]', function (event) {
      event.preventDefault();

      let data = $(this).data('click');

      new Action(data, this);
    });


    // Открыть модальное окно
    $body.on('click', '.js--modal--action', function (event) {
      event.preventDefault();

      let $modal = $('#modal-ajax');
      let isActive = $modal.hasClass('active');
      let data = {};

      if (isActive) {
        data = {
          '#modal-ajax .fade': {'addClass': 'animated fadeOut'},
          '#modal-ajax .content': {'addClass': 'animated zoomOutDown'},
        };
        new Action(data, this);

        setTimeout(function () {
          data = {
            '#modal-ajax': {'removeClass': 'active'},
            '#modal-ajax .fade': {'removeClass': 'animated fadeOut'},
            '#modal-ajax .content': {'removeClass': 'animated zoomOutDown'},
          };
          new Action(data, this);
        }, 1000);
      }else {
        data = {
          '#modal-ajax': {'ajax': {'selector': '#modal-ajax .ajax'}, 'addClass': 'active'},
          '#modal-ajax .fade': {'addClass': 'animated fadeIn'},
          '#modal-ajax .content': {'addClass': 'animated zoomInDown'},
        };
        new Action(data, this);

        setTimeout(function () {
          data = {
            '#modal-ajax .fade': {'removeClass': 'animated fadeIn'},
            '#modal-ajax .content': {'removeClass': 'animated zoomInDown'},
          };
          new Action(data, this);
        }, 1000);
      }
    });


    // Открыть навигацию
    $body.on('click', '.js--nav--action', function (event) {
      event.preventDefault();

      let $nav = $('nav');
      let isActive = $nav.hasClass('active');
      let data = {};

      if (isActive) {
        data = {
          'nav': {'addClass': 'animated fadeOutLeft faster'},
        };
        new Action(data, this);

        setTimeout(function () {
          data = {
            'nav': {'removeClass': 'active animated fadeOutLeft faster'},
          };
          new Action(data, this);
        }, 1000);
      }else {
        data = {
          'nav': {'addClass': 'active animated fadeInLeft faster'},
        };
        new Action(data, this);

        setTimeout(function () {
          data = {
            'nav': {'removeClass': 'animated fadeInLeft faster'},
          };
          new Action(data, this);
        }, 1000);
      }
    });


    let $fix = $('.js--fix');
    if ($fix.length) {
      $fix.each(function () {
        let $this = $(this);

        $this.data({'offsetTop': $this.offset().top});
      });

      $window.on('scroll', function () {
        let scrollTop = $window.scrollTop();

        $fix.each(function () {
          let $this = $(this);
          let offset = $this.data('offsetTop');

          if (scrollTop > offset) $this.addClass('fixed');
          else $this.removeClass('fixed');
        });

      });
    }


    if ($('.js--viewports').length) {
      $window.on('scroll load', function () {
        let height = $window.height();
        let top = $window.scrollTop();
        let center = top + height / 2;

        $('.js--viewports [data-viewport]').each(function (index, element) {
          let $this = $(element);
          let top = $this.offset().top;
          let bottom = $this.height() + top;
          let viewport = $this.data('viewport');

          if (center >= top && center < bottom) {
            $('[data-viewport-link=' + viewport + ']').addClass('active').siblings().removeClass('active');
          }

        });
      });
    }

    $body.on('change', '.js--redirect', function () {
      let $this = $(this);

      queryItems($this.val());
    });

    $body.on('click', '.js--redirect-link', function (event) {
      event.preventDefault();

      let $this = $(this);
      $this.addClass('active').siblings().removeClass('active');
      let url = $this.attr('href');
      if (!url) url = $this.find('a').attr('href');

      queryItems(url);
    });

    formValidate();
    slickInit();

  });
})(jQuery);


function slickInit () {
  let $slider = $('[data-slider]:not(.js--active)');
  console.log($slider);
  if ($slider.length) {
    $slider.addClass('js--active').each(function () {
      let $this = $(this);
      let data = $this.data('slider');

      $this.slick(data);
    });
  }
}

function queryItems (url) {
  $.ajax({
    url,
    data: {isNaked: 1},
    success (data) {
      let $data = $(data);
      let $items = $data.find('.js--ajax-item');

      $('.js--ajax-items').html($items);
      slickInit();
    },
  });

}
